import { FC, ReactNode } from 'react'

import { cn } from '@/app/utils'

type InfoItem = {
  key: string | number
  icon?: JSX.Element
  value?: ReactNode
}

type Props = {
  infoItems: InfoItem[]
  className?: string
}

const UserProfileInfo: FC<Props> = ({ infoItems, className }) => {
  return (
    <div className={cn('divide-y divide-grey-30', className)}>
      {infoItems.map(item => (
        <div
          key={item.key}
          className="flex items-start py-16 first:pt-0 last:pb-0 lg:py-12"
        >
          {item.icon && (
            <div className="mr-12 mt-2 flex h-24 w-24 flex-shrink text-grey-70 lg:h-20 lg:w-20">
              {item.icon}
            </div>
          )}
          <div className="font-pro text-20 lg:text-16">{item.value}</div>
        </div>
      ))}
    </div>
  )
}

export default UserProfileInfo
